<template>
	<div class="report_container full">
		<!-- 		<div style="position: relative;margin-top: 10px;">
			<statics-index ref="invoicestaticsIndex" />
		</div> -->
		<div style="position: relative;margin-top: 30px;">
			<el-row :gutter="20">
				<el-col :span="12">
					<el-divider content-position="center">专票开票时效</el-divider>
					<el-card class="box-card">
						<el-tabs v-model="validityName">
							<el-tab-pane label="申请待开票【48小时内】" name="apply">
								<apply-index />
							</el-tab-pane>
							<el-tab-pane label="已超时【超过48小时】" name="overtime">
								<overtime-index />
							</el-tab-pane>
						</el-tabs>
					</el-card>
				</el-col>
				<el-col :span="12">
					<el-divider content-position="center">累计开票金额</el-divider>
					<el-card class="box-card">
						<charttotalinvoice-index ref="charttotalinvoiceIndexIndex" />
					</el-card>
				</el-col>
			</el-row>
		</div>
		<div style="position: relative;margin-top: 30px;">
			<el-divider content-position="center">总开票统计</el-divider>
			<el-card class="box-card">
				<statics-index style="margin-bottom: 30px;" ref="invoicestaticsIndex" />
				<el-divider></el-divider>
				<el-radio-group v-model="staticsTime" size="mini" @change="staticsTimeChange">
					<el-radio-button label="年度累计"></el-radio-button>					
					<el-radio-button v-for="(item,index) in staticsTimeData" :label="item.time" :key="index"></el-radio-button>
				</el-radio-group>
				<vxe-grid class="" v-bind="list_gridOptions" v-if="list_gridOptions"
					@toolbar-button-click="list_toolbarButtonClickEvent" :ref="reportName+'_list'">
				</vxe-grid>

				<el-divider></el-divider>
				<div style="position: relative;margin-top: 10px;height: 400px;">
					<el-col :span="24" style="position: relative;height: 100%;">
						<chartoutamount-index ref="chartoutamountIndexIndex" />
					</el-col>
				</div>
			</el-card>
		</div>
		<div style="position: relative;width: 100%;height: 50px;"></div>
	</div>
</template>
<style>

</style>
<style scoped>

</style>
<script>
	import staticsIndex from './lib/statics/index.vue'
	import chartoutamountIndex from './lib/chart/outamount.vue'
	import charttotalinvoiceIndex from './lib/chart/totalinvoice.vue'


	import applyIndex from './lib/apply/index.vue'
	import overtimeIndex from './lib/overtime/index.vue'
	import listMixins from '@_system/components/base/mixins/list/list.js'
	export default {
		mixins: [listMixins],
		name: 'report',
		props: {

		},
		data() {
			return {
				staticsTime:'年度累计',
				staticsTimeData:[],
				validityName: 'apply',
				outputmerge: [],
				company:[],
				list_formConfig: [{
					field: 'date',
					title: '统计月份',
					resetValue: this.$Moment().startOf('month').valueOf(),
					itemRender: {
						defaultValue: this.$Moment().startOf('month').valueOf(),
						name: '$datePicker',
						props: {
							type: 'month'
						}
					}
				}],
				list_footerField: [{
					type: 'seq',
					field: 'code',
					title: '汇总',
				}, {
					type: 'field',
					field: 'outamount',
					toFixed: 2
				}, {
					type: 'field',
					field: 'costamount',
					toFixed: 2
				}, {
					type: 'field',
					field: 'inamount',
					toFixed: 2
				}, {
					type: 'field',
					field: 'remain',
					toFixed: 2
				}],
				reportName: 'invoice',
				windowName: '发票统计',
				pagerConfig: {
					autoHidden: true,
					border: true,
					size: 'mini',
					perfect: false,
					currentPage: 1,
					pageSize: 20,
					pageSizes: [10, 20, 50, 100, 200, 500, 1000, 2000, 5000],
				},
				
			}
		},
		watch: {

		},
		created() {

		},
		mounted() {


		},
		computed: {

		},

		methods: {
			list_beforeCreateGrid(gridOptions) {
				gridOptions.height = 500
				gridOptions.formConfig.enabled = false
				gridOptions.formConfig.span = 4
				gridOptions.columns = [{
					field: 'taxno',
					title: '税号'
				}, {
					field: 'companyname',
					title: '开票公司'
				}, {
					field: 'companytype',
					title: '公司性质'
				}, {
					field: 'outamount',
					title: '销项金额(所有)'
				}, {
					field: 'costamount',
					title: '暂估成本'
				}, {
					field: 'inamount',
					title: '进项金额(专票)'
				}, {
					field: 'remain',
					title: '年度累计差额'
				}]
			},
			list(page, updateForm, other) {
				this.staticsTime = '年度累计'
				this.staticsTimeData = []
				this.$refs.invoicestaticsIndex.load()
				return new Promise(resolve => {
					this.$api.report.reportlist(this.reportName, {
						...page,
						...updateForm,
						...other,
						...this.foreingKey
					}).then((res) => {
						//let data = []
						this.$refs.chartoutamountIndexIndex.createChart(res.outputmerge, res.nazhiinput)
						this.$refs.charttotalinvoiceIndexIndex.createChart()
						this.outputmerge = res.outputmerge
						this.company = res.company
						this.totaltabledata = this.createData(res.merge)
						
						let grouptime = this.$Lodash.groupBy(res.merge, 'invoicetime')
						//let index = 0
						for(let i in grouptime){
							let tabledata = this.createData(grouptime[i])
							tabledata.forEach((item)=>{
								let exist = this.totaltabledata.find((_item)=>{
									return item.taxno == _item.taxno
								})
								if(exist){
									item.remain = exist.remain
								}
							})	
							// if(index>0){
							// 	tabledata.forEach((item)=>{
							// 		let exist = this.staticsTimeData[index-1].tabledata.find((_item)=>{
							// 			return item.taxno == _item.taxno
							// 		})
							// 		if(exist){
							// 			item.computeremain = parseFloat(item.computeremain) + parseFloat(exist.computeremain)
							// 			item.remain = item.remain.toFixed(2)
							// 		}
							// 	})								
							// }
							this.staticsTimeData.push({
								time:i,
								tabledata:tabledata
							})
							//index++
						}

						// let group = this.$Lodash.groupBy(res.merge, 'taxno')
						// for (let i in group) {
						// 	let outamount = this.$Lodash.sumBy(group[i], (item) => {
						// 		return parseFloat(item.outamount)
						// 	})
						// 	let costamount = this.$Lodash.sumBy(group[i], (item) => {
						// 		return parseFloat(item.costamount)
						// 	})
						// 	let inamount = this.$Lodash.sumBy(group[i], (item) => {
						// 		return parseFloat(item.inamount)
						// 	})
						// 	data.push({
						// 		companyname: group[i][0].companyname,
						// 		taxno: group[i][0].taxno,
						// 		outamount: outamount.toFixed(2),
						// 		costamount: costamount.toFixed(2),
						// 		inamount: inamount.toFixed(2),
						// 		remain: (costamount - inamount).toFixed(2)
						// 	})
						// }
						resolve({
							list: this.totaltabledata
						})
					}, () => {
						resolve([])
					})
				})
			},
			createData(data){
				let group = this.$Lodash.groupBy(JSON.parse(JSON.stringify(data)), 'taxno')
				let tabledata = []
				for (let i in group) {
					let outamount = this.$Lodash.sumBy(group[i], (item) => {
						return parseFloat(item.outamount)
					})
					let costamount = this.$Lodash.sumBy(group[i], (item) => {
						return parseFloat(item.costamount)
					})
					let inamount = this.$Lodash.sumBy(group[i], (item) => {
						return parseFloat(item.inamount)
					})
					let company = this.company.find((item)=>{
						return item.taxid == group[i][0].taxno
					})
					let companytype = null
					if(company){
						console.log(company.companytype,111)
						companytype = window.systemMethods.getEmunValue('companytype',company.companytype)
					}
					
					tabledata.push({
						id: group[i][0].id,
						companyname: group[i][0].companyname,
						companytype:companytype,
						taxno: group[i][0].taxno,
						outamount: outamount.toFixed(2),
						costamount: costamount.toFixed(2),
						inamount: inamount.toFixed(2),
						remain: (costamount - inamount).toFixed(2),
						computeremain:costamount - inamount
					})
				}
				return tabledata
			},
			staticsTimeChange(e){
				if(e == '年度累计'){
					this.$refs.invoicestaticsIndex.load()
					this.$refs[this.reportName+'_list'].reloadData(this.totaltabledata)
				}else{
					let exist = this.staticsTimeData.find((item)=>{
						return item.time == e
					})	
					let tabledata = []			
					if(exist){
						tabledata = exist.tabledata
						this.totaltabledata.forEach((item)=>{
							let companyexist = tabledata.find((_item)=>{
								return item.taxno == _item.taxno
							})
							if(!companyexist){
								tabledata.push({
									id:item.id,
									companyname:item.companyname,
									taxno:item.taxno,									
									// outamount:0,
									// costamount:0,
									// inamount:0,
									remain:item.remain,
								})
								
							}
						})
						
						


					}
					this.$refs.invoicestaticsIndex.load({month:e})
					this.$refs[this.reportName+'_list'].reloadData(tabledata)
				}
			}

		},
		components: {
			applyIndex,
			overtimeIndex,
			staticsIndex,
			chartoutamountIndex,
			charttotalinvoiceIndex
		}
	}
</script>